export default __webpack_public_path__ + "static/media/Pulse-1s-51px.7a9b46b2.gif";